import React from 'react';
import AddMedication from '../../Main/AddMedications';
import ShowMedications from '../../Main/ShowMedications';
import userService from '../../user.service';
import { refresh, logout } from '../../utils/index';
import NewUserInfo from '../../Main/NewUserInfo';
import { Grid, makeStyles } from '@material-ui/core';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from '../../Main/main.styles';
import EmergencyButton from '../Components/EmergencyButton';
import useStore from '../../Store/Store';
import RecipientsSelector from '../Components/RecipientsSelector';
import AddMedicationModal from './components/AddMedicationModal';

const useStyles = makeStyles(styles);

const Medications = () => {
  const classes = useStyles();
  const history = useNavigate();
  const user = useStore((state) => state.user);
  const selectedRecipient = useStore((state) => state.selectedRecipient);
  const width = useStore((state) => state.screenWidth);

  const [showMedicationTable, setShowMedicationTable] = React.useState(false);

  const location = useLocation();

  const query = new URLSearchParams(location.search);

  React.useEffect(() => {
    if (query.get('addMeds') === '1') {
      setShowMedicationTable(true);
    }
  }, [query]);

  const closeMedsTable = () => {
    query.delete('addMeds');
    history({ search: query.toString() });
    setShowMedicationTable((prev) => !prev);
  };

  return (
    <>
      <NewUserInfo />
      <div className="flex-column-a" style={{ left: width > 850 ? '15%' : '0%' }}>
        <RecipientsSelector />
        <ShowMedications
          //   closeModal={closeMedications}
          user={user}
          setShowMedicationTable={closeMedsTable}
          refresh={refresh}
          selectedRecipient={selectedRecipient}
        />
        {/* {showMedicationTable ? (
          <ShowMedications
            //   closeModal={closeMedications}
            user={user}
            setShowMedicationTable={closeMedsTable}
            refresh={refresh}
            selectedRecipient={selectedRecipient}
          />
        ) : (
          <AddMedication
            user={user}
            //   closeModal={closeMedications}
            refresh={refresh}
            setShowMedicationTable={closeMedsTable}
            canCare={true}
            selectedRecipient={selectedRecipient}
          />
        )} */}
      </div>
      <AddMedicationModal show={showMedicationTable} onClose={closeMedsTable} refresh={refresh} />
      <EmergencyButton />
    </>
  );
};

export default Medications;
